import React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

import { TextField } from '@mui/material';
import classNames from 'classnames';

const filter = createFilterOptions();

export const ComboBox = (props) => {
  return (
    <div
      className={classNames('input', {
        hasValue: !!props.value,
        disabled: props.disabled,
      })}>
      <div className="input__container">
        {props.label && <label htmlFor={props.name}>{props.label}</label>}
        <Autocomplete
          value={props.value}
          onChange={props.onChange}
          disableClearable
          disablePortal
          id={props.name}
          options={props.options}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            const { inputValue } = params;

            if (props.fallback && inputValue !== '' && !filtered.length) {
              filtered.push(props.fallback);
            }

            return filtered;
          }}
          sx={{
            width: '100%',
            '& .MuiFormControl-root': { height: 0 },
            '& .MuiAutocomplete-input': { p: '0 !important' },
          }}
          renderInput={(params) => (
            <TextField
              sx={{
                '& .MuiInputBase-root': { py: 0, pl: 0 },
                '& .MuiButtonBase-root': { p: 0 },
              }}
              {...params}
            />
          )}
        />
      </div>
    </div>
  );
};